export enum ContractSortField {
    CreatedDate,
    UpdatedDate,
    NumberProcess,
    ContractEffortNumber,
    Year,
    Sequence,
    ProcessCategory,
    ContractType,
    SupplierName,
    ClientName
}
